module.exports = __webpack_public_path__ + "hotspot-46a8111df1be994ff0b01c3da747e61e.png";